import { endPoints } from "../../constant/api_constants/url";
import { API_METHODS } from "../../enums";
import { fetchApi } from "../../utils/apiFunction";
import { consoleLog } from "../../utils/consoleLog/consoleLog";

export const promoReviewCart = async (accessJWT: string, requestBody: any) => {
  // Version routing for /price/review. The whole hotel pipeline is now v2 (hotel
  // search / room-pricing / availability are all hardcoded v2), so any cart that
  // contains hotels is priced as v2 — unconditionally, no longer gated on the
  // `_zenvoya_chat_hotel_origin` flag or a `_v2`-suffixed sessionId. This also
  // satisfies the v2 booking-engine's hard rule that a hotels[].sessionId ending
  // in "_v2" REQUIRES version:"v2" (it 400s otherwise).
  // Scope: applied only when the cart HAS hotels — a flight-only /price/review is
  // left untouched (no version field) so this change stays confined to hotel APIs.
  // Caller-supplied `version` still wins via spread order.
  const hasHotels = Array.isArray(requestBody?.hotels) && requestBody.hotels.length > 0;
  const finalBody = {
    ...(hasHotels ? { version: "v2" } : {}),
    ...requestBody,
  };
  consoleLog(["API REQUEST", endPoints.priceReview, finalBody]);
  const response = await fetchApi(accessJWT, endPoints.priceReview, API_METHODS.POST, finalBody, null);
  consoleLog(["API RESPONSE", endPoints.priceReview, response]);
  // V2 chat-hotel diagnostic: the caller (useSelectRoomHooks) currently treats
  // any non-200 as `null`, hiding the real statusCode + message. Surface the
  // raw envelope here so the chat-driven failure mode is observable in console.
  // eslint-disable-next-line no-console
  console.log("[v2-FE-price-review-raw]", {
    statusCode: response?.statusCode,
    message: response?.message,
    error: response?.error,
    dataKeys: response?.data ? Object.keys(response.data) : null,
    raw: response,
  });
  if (response?.statusCode === 200)
    return response.data
  else
    return null
};

export const getPromoDetails = async (accessJWT: string, requestBody: any) => {
  try {
    const response = await fetchApi(accessJWT, endPoints.getPromoCode, API_METHODS.POST, requestBody, null);
    consoleLog(["API RESPONSE", endPoints.getPromoCode, response]);
    return response;
  } catch (error) {
    consoleLog(["API ERROR", endPoints.getPromoCode, error]);
    return { statusCode: 500, data: null, error: "Failed to get promo details" };
  }
};
